import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import { DraftRenderer } from '../styled-text-editor';
import withFontClassName from '../../hoc/with-font-class-name';
import withPermissions from '../../hoc/with-permissions';

export function PostContent({ post, contentFontClassName, can } = {}) {
  let postBody;

  if (typeof post.content === 'object') {
    postBody = <DraftRenderer content={post.content} isPublic={can('share', 'post', post)}/>;
  }

  return (
    <article className={contentFontClassName}>
      <div className="post-content__body" tabIndex="0">
        {postBody}
      </div>
    </article>
  );
}

PostContent.propTypes = {
  post: PropTypes.object.isRequired,
  contentFontClassName: PropTypes.string.isRequired,
  can: PropTypes.func,
};

export default _.flowRight(withFontClassName, withPermissions)(PostContent);



// WEBPACK FOOTER //
// ./app/components/post-content/post-content.js